class PreloaderHandler {
  constructor() {
    this.queue = [];
  }

  /**
   * Add a loading key to the queue.
   * @param key
   * @returns {String}
   */
  signalLoading(key) {
    key = this.generateLoadingKey(key);

    this.queue.unshift(key);

    return key;
  }

  /**
   * Remove a loading key from the queue.
   *
   * @param key
   * @returns {boolean}
   */
  signalComplete(key) {
    let index = this.queue.indexOf(key);

    if (index > -1) {
      this.queue.splice(index, 1);
      return true;
    }
  }

  /**
   * Generate a unique loading key.
   *
   * @param key
   * @returns {string}
   */
  generateLoadingKey(key) {
    return key + '-' + window.performance.now();
  }
}

export default PreloaderHandler;
